<template>
  <AppHeader>Empty Bottle Summary</AppHeader>

  <FromToDate @filter="getData"></FromToDate>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table" v-if="data.length != 0">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Sent 1L</th>
            <th>Ret. 1L</th>
            <th>Pending 1L</th>
            <th>Sent 500ml</th>
            <th>Ret. 500ml</th>
            <th>Pending 500ml</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Total</b></td>
            <td><b>{{ total.sent_1l }}</b></td>
            <td><b>{{ total.returned_1l }}</b></td>
            <td><b>{{ total.net_1l }}</b></td>
            <td><b>{{ total.sent_500ml }}</b></td>
            <td><b>{{ total.returned_500ml }}</b></td>
            <td><b>{{ total.net_500ml }}</b></td>
          </tr>
          <tr v-for="date in data" :key="date.date">
            <td>{{ date.date }}</td>
            <td>{{ date.sent_1l }}</td>
            <td>{{ date.returned_1l }}</td>
            <td>{{ date.net_1l }}</td>
            <td>{{ date.sent_500ml }}</td>
            <td>{{ date.returned_500ml }}</td>
            <td>{{ date.net_500ml }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-center text-gray-500" v-else>
      <p>Please select From & To date to filter</p>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import FromToDate from '@/components/common/FromToDate.vue';

export default {
  name: 'ReportEmptyBottleSummary',
  mixins: [ mixin ],
  components: { AppHeader, Loading, FromToDate },
  data() {
    return {
      state: 'idle',
      data: [],
      total: {},
    }
  },

  methods: {
    getData(from, to) {
      this.state = 'loading';

      this.request('GET', 'reports/emptybottle-summary?from=' + from + '&to=' + to, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.calculateTotal(resp.data);
        else alert(resp.message);
      });
    },

    calculateTotal(data) {
      let total = {total: 0, returned_500ml: 0, returned_1l: 0, sent_500ml: 0, sent_1l: 0, net_500ml: 0, net_1l: 0};

      data.forEach(entry => {
        total['returned_500ml'] += entry['returned_500ml'];
        total['returned_1l'] += entry['returned_1l'];
        total['sent_500ml'] += entry['sent_500ml'];
        total['sent_1l'] += entry['sent_1l'];
        total['net_500ml'] += entry['net_500ml'];
        total['net_1l'] += entry['net_1l'];
      });

      this.data = data;
      this.total = total;
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
  }
}
</script>
